import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDownload(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.75 14.417v2.424a2.91 2.91 0 0 1-2.91 2.909H6.66a2.91 2.91 0 0 1-2.91-2.91v-2.423m8 .242V3.75m0 10.91-3.394-3.395m3.394 3.394 3.394-3.394"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
